import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'toggle'
        }
    }

    init() {

    }

    toggle(e) {
        e.preventDefault()

        const id = this.getData('id')
        const host = this.getData('host')

        this.call('open', { id, host }, 'VideoModal')
    }
}
